import React from "react";
import "./checkButton.css";
import PropTypes from "prop-types";

const Checkbox = (props) => {
  const { checked, onChange, style, name, value } = props;
  return (
    <div>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <span className="custom-checkbox checkmark" style={{ ...style }} />
    </div>
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
};

export default Checkbox;
